import type { SVGProps } from "react";

export function IconBlackBookOpen(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 7.25C11.25 4.81185 9.02615 3 6.5 3C3.97385 3 1.75 4.81185 1.75 7.25V22.3154L3.09269 20.5838C3.65871 19.8539 4.9161 19.25 6.5 19.25C8.0839 19.25 9.34129 19.8539 9.90731 20.5838L11.25 22.3154V7.25ZM22.25 7.25C22.25 4.81185 20.0261 3 17.5 3C14.9739 3 12.75 4.81185 12.75 7.25V22.3154L14.0927 20.5838C14.6587 19.8539 15.9161 19.25 17.5 19.25C19.0839 19.25 20.3413 19.8539 20.9073 20.5838L22.25 22.3154V7.25Z"
        fill="#0B0C17"
      />
    </svg>
  );
}
